/* Adikopas — dydžio parinkimas pagal ūgį (veikia ir su sąrašu, ir su mygtukais) */
(function () {
  var CSS = [
    '.adk-h{grid-column:1/-1;flex:1 0 100%;width:100%;margin:12px 0 0;font-size:.85rem}',
    '.adk-h__row{display:flex;align-items:center;gap:8px;flex-wrap:wrap}',
    '.adk-h__lab{opacity:.75}',
    '.adk-h__in{width:82px;padding:6px 8px;border:1px solid var(--color-input-border,#ccc);border-radius:var(--style-border-radius-inputs,4px);background:var(--color-input-background,#fff);color:inherit;font:inherit}',
    '.adk-h__out{margin-top:8px;line-height:1.45}',
    '.adk-h__out b{font-weight:700}',
    '.adk-h__note{opacity:.7;display:block;margin-top:2px;font-size:.95em}',
    '.adk-h__pick{margin:6px 6px 0 0;padding:5px 12px;border:1px solid currentColor;background:none;color:inherit;font:inherit;font-size:.9em;border-radius:var(--style-border-radius-inputs,4px);cursor:pointer}',
    '.adk-h__pick:hover{background:rgb(var(--color-foreground-rgb)/.07)}'
  ].join('');

  function css() {
    if (document.getElementById('adk-h-css')) return;
    var s = document.createElement('style');
    s.id = 'adk-h-css'; s.textContent = CSS;
    document.head.appendChild(s);
  }

  var DASH = /[–—]/g;
  function norm(s) { return (s || '').toLowerCase().replace(DASH, '-').replace(/\s+/g, ''); }
  function low(s) { return (s || '').toLowerCase(); }
  function nums(s) {
    var m = (s || '').replace(DASH, '-').match(/\d+/g);
    return m ? m.map(Number) : [];
  }

  function control() {
    var sel = [].slice.call(document.querySelectorAll('select')).filter(function (el) {
      return /dydis|size/i.test(el.name || '');
    })[0];
    if (sel) {
      return {
        kind: 'select',
        values: [].map.call(sel.options, function (o) { return o.value; }).filter(Boolean),
        wrap: sel.parentElement,
        node: sel,
        set: function (val) {
          for (var i = 0; i < sel.options.length; i++) {
            if (norm(sel.options[i].value) === norm(val)) {
              sel.value = sel.options[i].value;
              sel.dispatchEvent(new Event('change', { bubbles: true }));
              return;
            }
          }
        },
        others: function () {
          return [].slice.call(document.querySelectorAll('select')).filter(function (el) {
            return el !== sel && /options/i.test(el.name || '');
          }).map(function (el) { return low(el.value).trim(); }).filter(Boolean);
        }
      };
    }

    var radios = [].slice.call(document.querySelectorAll('input[type=radio]')).filter(function (i) {
      return /^(dydis|size)/i.test(i.name || '');
    });
    if (!radios.length) return null;
    var group = radios[0].name;
    var fs = radios[0].closest('fieldset') || radios[0].parentElement;
    return {
      kind: 'radio',
      values: radios.map(function (r) { return r.value; }).filter(Boolean),
      wrap: fs,
      node: fs,
      set: function (val) {
        var t = radios.filter(function (r) { return norm(r.value) === norm(val); })[0];
        if (!t) return;
        var lab = t.closest('label');
        if (lab) { lab.click(); } else { t.click(); }
      },
      others: function () {
        return [].slice.call(document.querySelectorAll('input[type=radio]')).filter(function (i) {
          return i.checked && i.name !== group;
        }).map(function (i) { return low(i.value).trim(); }).filter(Boolean);
      }
    };
  }

  function parseTable(tbl) {
    var head = tbl.querySelectorAll('thead th');
    if (!head.length) return null;
    var hi = -1;
    for (var i = 0; i < head.length; i++) {
      var h = low(head[i].textContent);
      if (h.indexOf('ūgis') > -1 || h.indexOf('ugis') > -1) { hi = i; break; }
    }
    if (hi < 1) return null;
    var rows = [];
    [].forEach.call(tbl.querySelectorAll('tbody tr'), function (tr) {
      var td = tr.querySelectorAll('td');
      if (td.length <= hi) return;
      var n = nums(td[hi].textContent);
      if (!n.length) return;
      rows.push({
        label: (td[0].textContent || '').trim(),
        key: norm(td[0].textContent),
        min: n[0],
        max: n.length > 1 ? n[1] : n[0]
      });
    });
    return rows.length ? rows : null;
  }

  function headingOf(tbl, box) {
    var node = tbl;
    while (node.parentElement && node.parentElement !== box) node = node.parentElement;
    var h = node.previousElementSibling;
    while (h && !/^H[2-4]$/.test(h.tagName)) h = h.previousElementSibling;
    return low(h ? h.textContent : '');
  }

  function build() {
    var box = document.querySelector('.adk-modal__box');
    if (!box) return;

    var ctl = control();
    if (!ctl) return;
    var others = ctl.others();

    var blocks = [];
    [].forEach.call(box.querySelectorAll('table'), function (t) {
      blocks.push({ rows: parseTable(t), head: headingOf(t, box) });
    });

    var withRows = blocks.filter(function (b) { return b.rows; });
    var old = document.querySelector('.adk-h');
    if (!withRows.length) { if (old) old.remove(); return; }

    var chosen = null, matched = false;
    if (blocks.length > 1 && others.length) {
      var m = blocks.filter(function (b) {
        return others.some(function (o) { return o && b.head.indexOf(o) > -1; });
      })[0];
      if (m) {
        if (!m.rows) { if (old) old.remove(); return; }
        chosen = m;
        matched = true;
      }
    }
    if (!chosen) {
      if (withRows.length !== 1) { if (old) old.remove(); return; }
      chosen = withRows[0];
    }

    var opts = ctl.values.map(function (v) { return { v: v, k: norm(v) }; });
    if (!opts.length) return;
    var keys = chosen.rows.map(function (r) { return r.key; });
    var covered = opts.filter(function (o) { return keys.indexOf(o.k) > -1; }).length;
    if (covered / opts.length < 0.7 || (!matched && keys.indexOf(opts[opts.length - 1].k) < 0)) {
      if (old) old.remove();
      return;
    }

    var wrap = ctl.wrap;
    if (ctl.kind === 'select') {
      for (var i = 0; i < 3 && wrap && !wrap.querySelector('label, legend'); i++) wrap = wrap.parentElement;
      wrap = wrap || ctl.node.parentElement;
    }

    var el = wrap.querySelector('.adk-h');
    if (!el) {
      el = document.createElement('div');
      el.className = 'adk-h';
      el.innerHTML = '<div class="adk-h__row"><span class="adk-h__lab">Nežinai dydžio? Įrašyk ūgį</span>' +
        '<input class="adk-h__in" type="number" inputmode="numeric" min="90" max="230" placeholder="cm"></div>' +
        '<div class="adk-h__out"></div>';
      wrap.appendChild(el);
    }
    var input = el.querySelector('.adk-h__in');
    var out = el.querySelector('.adk-h__out');
    el.rowsData = chosen.rows;

    function heightField() {
      return [].slice.call(document.querySelectorAll('product-custom-property-component input')).filter(function (i) {
        var n = '';
        try { n = decodeURIComponent(i.getAttribute('name') || '').toLowerCase(); } catch (e) { n = low(i.getAttribute('name')); }
        return n.indexOf('gis') > -1 || n.indexOf('height') > -1;
      })[0];
    }

    function render() {
      var rows = el.rowsData;
      var h = parseInt(input.value, 10);
      out.innerHTML = '';
      if (!h || h < 60 || h > 260) return;

      var hf = heightField();
      if (hf && !hf.value) { hf.value = String(h); hf.dispatchEvent(new Event('input', { bubbles: true })); }

      var hit = rows.filter(function (r) { return h >= r.min && h <= r.max; });
      var msg = document.createElement('div');

      if (!hit.length) {
        var best = null, bd = 1e9;
        rows.forEach(function (r) {
          var d = h < r.min ? r.min - h : (h > r.max ? h - r.max : 0);
          if (d < bd) { bd = d; best = r; }
        });
        hit = [best];
        msg.innerHTML = 'Tikslaus atitikmens nėra — artimiausias dydis <b>' + best.label + '</b>.';
      } else if (hit.length === 1) {
        msg.innerHTML = 'Pagal ūgį siūlome dydį <b>' + hit[0].label + '</b>.';
      } else {
        msg.innerHTML = 'Pagal ūgį tinka <b>' + hit.map(function (r) { return r.label; }).join('</b> ir <b>') + '</b>.' +
          '<span class="adk-h__note">Ilgis vienodas, skiriasi apimtimi — jei nori laisviau, rinkis didesnį.</span>';
      }
      out.appendChild(msg);

      hit.forEach(function (r) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'adk-h__pick';
        b.textContent = 'Pasirinkti ' + r.label;
        b.addEventListener('click', function () { ctl.set(r.label); });
        out.appendChild(b);
      });
    }

    if (!el.getAttribute('data-bound')) {
      el.setAttribute('data-bound', '1');
      input.addEventListener('input', render);
    }
    if (input.value) render();
  }

  function run() { css(); build(); }

  var last = 0, timer = 0;
  function schedule() {
    var now = Date.now();
    if (now - last > 400) { last = now; run(); return; }
    clearTimeout(timer);
    timer = setTimeout(function () { last = Date.now(); run(); }, 400);
  }
  schedule();
  document.addEventListener('DOMContentLoaded', schedule);
  document.addEventListener('change', schedule, true);
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
})();